<template>
  <div class="contact-view">
    <div class="renew2_wrapper renew2_flex">
      <div class="contact_contents">
        <contact-form />
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from "../components/ContactForm.vue";

export default {
  name: "ContactView",
  components: {
    ContactForm,
  },
};
</script>

<style scoped>
.contact-view {
  width: 100%;
  background-color: #f0f7f0; /* 薄い緑色の背景を追加 */
  min-height: 130vh; /* ページ全体に背景色を適用 */
}

.renew2_wrapper {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
}

.renew2_flex {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
